/** Epoch ms/s → Date, solo si es número o string puramente numérico (10–13 dígitos). */
function toDateFromEpoch(value) {
    if (typeof value === 'number' && Number.isFinite(value)) {
        const ms = value < 1e12 ? value * 1000 : value;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    if (typeof value === 'string' && /^\d{10,13}$/.test(value.trim())) {
        const raw = value.trim();
        const n = Number(raw);
        const ms = raw.length <= 10 ? n * 1000 : n;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    return null;
}

/** Convierte datetime MySQL/API (UTC en BD) a hora Colombia (UTC-5). */
export function formatPagosFechaColombia(value) {
    if (value == null || value === '') return 'N/A';

    // Solo epoch numérico: no toca strings MySQL/ISO ni otros orígenes.
    const fromEpoch = toDateFromEpoch(value);
    if (fromEpoch) {
        value = fromEpoch;
    }

    // Siempre trabajar sobre string; nunca new Date("2026-07-02 18:57:00") (lo parsea como local).
    const str =
        value instanceof Date
            ? value.toISOString()
            : String(value).trim();

    const m = str.match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return 'N/A';

    const year = Number(m[1]);
    const month = Number(m[2]);
    const day = Number(m[3]);
    const hour = Number(m[4]);
    const minute = Number(m[5]);

    // Componentes = reloj UTC en MySQL → restar 5 h para Colombia (sin DST).
    let totalMin = hour * 60 + minute - 5 * 60;
    let d = day;
    let mo = month;
    let y = year;

    if (totalMin < 0) {
        totalMin += 24 * 60;
        const prev = new Date(Date.UTC(y, mo - 1, d - 1));
        y = prev.getUTCFullYear();
        mo = prev.getUTCMonth() + 1;
        d = prev.getUTCDate();
    }

    const hh = Math.floor(totalMin / 60);
    const mm = totalMin % 60;
    const pad = (n) => String(n).padStart(2, '0');

    return `${pad(d)}/${pad(mo)}/${y}, ${pad(hh)}:${pad(mm)}`;
}

/** Fecha/hora genérica (misma lógica UTC→Colombia para datetimes de API). */
const FormattedDate = (fechaISO) => formatPagosFechaColombia(fechaISO);

export default FormattedDate;
